import React from "react";
import {CoursePage } from "../components/Course";

const Fashion = () => (
  <CoursePage pageTitle={'Fashion'} />
);

export default Fashion;
